export const createHash = () => {
    return Math.random().toString(24)
}